import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {NonNegativeValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateNonNegativeNumber = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (!ValidationUtils.isValidationRule<NonNegativeValidationRule>(rule, StatisticItemValidationType.NonNegative)) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;
  const numberStatisticValue = Number(statisticValue);

  if (ValidationUtils.isInvalidNumberValue(statisticValue)) {
    // логируем не числовое значение
    const error = FrontendError.createParseNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue && numberStatisticValue < 0) {
    // логируем отрицательное числовое значение
    const error = FrontendError.createNegativeNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    const reversedValue = -numberStatisticValue;
    statisticValue = reversedValue.toString();
  }

  return statisticValue;
};
